import React from "react";
import Preloader from "./Preloader";

function LoadMore({
  entitiesFiltered,
  itemOffset,
  itemsPerPage,
  setItemOffset,
  loadingExtra,
  labels,
}) {
  const handlePageClick = (event) => {
    setItemOffset(itemOffset + itemsPerPage);
  };
  return (
    <>
      {(entitiesFiltered.length > itemOffset + itemsPerPage ||
        loadingExtra) && (
        <>
          <div className={"v-flex v-justify-center v-items-center "}>
            {loadingExtra ? (
              <Preloader />
            ) : (
              <div
                className={"v-mt-10 develop form-button"}
                onClick={() => handlePageClick()}
              >
                <span>{labels["more"]}</span>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default LoadMore;
